import { CategoryCard, MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledMethodContainer = styled.div`
  width: 100%;
  margin-bottom: 2rem;
`

export const StyledMethodSwitcherContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 0.5rem;
  margin-bottom: 12px;
`

export const StyledMethodCardWrapper = styled.div`
  width: 31%;
  height: 140px;
  ${MediaQueries.mbDown} {
    height: 130px;
    width: 32.5%;
  }
`
export const StyledCategoryCard = styled(CategoryCard)`
  width: 100%;
  height: 100%;
  justify-content: space-around;
  ${MediaQueries.mbDown} {
    padding: 0.25rem;
  }
  &.active {
    border-color: ${(props: ThemeProps) => props.theme.colors.primaryBase};
    box-shadow: none;
    p {
      color: ${(props: ThemeProps) => props.theme.colors.primaryBase};
    }
  }
`

export const StyledLastPeriodFormContainer = styled(StyledMethodContainer)`
  #due-date-dropdown {
    z-index: 10;
    width: 100%;
    min-width: unset;
    max-width: unset;
    margin-bottom: 2rem;
    color: ${(props: ThemeProps) => props.theme.colors.gray800};
  }
  .due-date-input {
    width: 100%;
    min-width: unset;
    max-width: unset;
    color: ${(props: ThemeProps) => props.theme.colors.gray800};
  }
  .due-date-calculate-button {
    margin-right: auto;
    margin-left: auto;
  }
`

export const StyledScrollLinkContainer = styled.div`
  display: flex;
  align-items: right;

  & > p {
    display: inline-block;
    border-bottom: solid 1px
      ${(props: ThemeProps) => props.theme.colors.primaryBase};
    margin-bottom: 24px;
    margin-left: auto;
    color: ${(props: ThemeProps) => props.theme.colors.primaryBase};
    cursor: pointer;
    font-size: 11px;
    line-height: 16px;
    text-align: right;
  }
`
export const StyledInfoContentWrapper = styled.div`
  margin-bottom: 1rem;
`
